import {
  resourceReducer,
} from 'redux-resource';
import {
  includedResources,
} from 'redux-resource-plugins';

import {
  allListPlugin,
  customListPlugin,
} from './plugins';

export default resourceReducer('groupAssignments', {
  plugins: [
    includedResources,
    customListPlugin,
    allListPlugin,
  ],
});
